import React from "react";
import { FaShieldAlt, FaRegFileAlt, FaRobot } from 'react-icons/fa';// Icons for visualization

const UserAgreementText = () => {
    return (
        <div className="prose max-w-full p-4">
            <h2><FaRegFileAlt className="inline mr-2" /> User Agreement</h2>
            <p><strong>Version:</strong> 1.0</p>

            <p>
                This agreement governs the processing of personal data in accordance with the General Data Protection Regulation (GDPR) and the use of artificial intelligence (AI) technologies in our service.
            </p>

            <h3><FaShieldAlt className="inline mr-2" /> GDPR Compliance</h3>
            <ul>
                <li><strong>Article 5:</strong> Personal data shall be processed lawfully, fairly, and in a transparent manner.</li>
                <li><strong>Article 6:</strong> Processing is permitted only on lawful grounds (consent, contract, legal obligation).</li>
                <li><strong>Article 7:</strong> Consent must be freely given, specific, informed, and unambiguous.</li>
                <li><strong>Article 9:</strong> Special categories of personal data (e.g., health, biometrics) are processed only with legal justification.</li>
                <li><strong>Article 12:</strong> Transparent communication of data processing activities is ensured.</li>
                <li><strong>Article 14:</strong> Users are informed if data is collected from third parties.</li>
                <li><strong>Article 17:</strong> Users have the right to erasure ("right to be forgotten").</li>
                <li><strong>Article 22:</strong> Users shall not be subject to decisions based solely on automated processing.</li>
            </ul>

            <h3><FaRobot className="inline mr-2" /> Use of Artificial Intelligence (AI)</h3>
            <p>
                We utilize AI technologies to improve logistics, predict demand, and automate operations. All critical decisions that may affect user rights are supervised by humans. AI is not used to make final decisions without human intervention.
            </p>

            <p>
                By registering, you agree to the terms outlined above and consent to the processing of your data accordingly.
            </p>
        </div>
    );
};

export default UserAgreementText;
